import React from 'react'

export default props => (
  <svg viewBox="0 0 14 10" {...props}>
    <polygon points="5 10 0 5.19230769 1.4 3.84615385 5 7.30769231 12.6 0 14 1.34615385" />
  </svg>
)
